if (!customElements.get('yrp-restock-request')) {
customElements.define('yrp-restock-request', class extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.root = document.getElementById('ProductInfo-' + this.dataset.section) || this.closest('section');
    this.dialog = this.querySelector('dialog');
    this.variants = JSON.parse(this.querySelector('[data-restock-variants]').textContent);
    this.currentVariant = () => {
      const picker = this.root.querySelector('variant-radios,variant-selects');
      let options = [];
      if (picker) {
        options = [...picker.querySelectorAll('fieldset')].map(fieldset => fieldset.querySelector('input:checked')?.value);
        if (!options.length) options = [...picker.querySelectorAll('select')].map(select => select.value);
      }
      if (options.length) return this.variants.find(v => v.options.every((option, index) => option === options[index]));
      return this.variants.find(v => String(v.id) === this.dataset.initialVariant);
    };
    this.update = () => {
      const variant = this.currentVariant();
      if (!variant) return;
      const set = (selector, value) => { const field = this.querySelector(selector); if (field) field.value = value; };
      const title = variant.title === 'Default Title' ? '' : variant.title;
      this.querySelector('[data-restock-selection]').textContent = title;
      set('[data-restock-variant]', variant.title);
      set('[data-restock-id]', variant.id);
      const urlField = this.querySelector('[data-restock-url]');
      if (urlField) urlField.value = urlField.dataset.productUrl + '?variant=' + variant.id;
      const productTitle = this.querySelector('[name="contact[Produkt]"]')?.value || '';
      set('[data-restock-body]', productTitle + ' — ' + variant.title + ' — ' + (urlField?.value || ''));
    };
    this.onClick = event => {
      const button = event.target.closest('.product-form__submit');
      if (!button || !this.root.contains(button)) return;
      const variant = this.currentVariant();
      if (!variant || variant.available) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.opener = button;
      this.update();
      this.dialog.showModal();
      this.querySelector('input[type=email]')?.focus();
    };
    this.onChange = () => queueMicrotask(this.update);
    this.onClose = () => this.opener?.focus();
    this.onBackdrop = event => { if (event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close(); } };
    this.onCloseButton = () => this.dialog.close();
    this.root.addEventListener('click', this.onClick, true);
    this.root.addEventListener('change', this.onChange);
    this.dialog.addEventListener('close', this.onClose);
    this.dialog.addEventListener('click', this.onBackdrop);
    this.querySelector('[data-restock-close]').addEventListener('click', this.onCloseButton);
    this.update();
    if (this.querySelector('[data-restock-response]')) this.dialog.showModal();
  }
  disconnectedCallback() {
    this.root?.removeEventListener('click', this.onClick, true);
    this.root?.removeEventListener('change', this.onChange);
    this.dialog?.close();
    this.bound = false;
  }
});
}
